import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { ArrowBackIcon, ExternalLinkIcon } from '@chakra-ui/icons';

interface ContactProps {
  onBack?: () => void;
}

const Contact: React.FC<ContactProps> = ({ onBack }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('gray.800', 'white');

  const handleGoogleFormOpen = () => {
    const googleFormUrl = 'https://forms.gle/FVtw4SDdJX8gnCPk7';
    window.open(googleFormUrl, '_blank');
  };

  return (
    <Container maxW="container.md" py={8}>
      {onBack && (
        <Button
          leftIcon={<ArrowBackIcon />}
          onClick={onBack}
          mb={4}
          variant="ghost"
          size="sm"
        >
          戻る
        </Button>
      )}
      <Box bg={bgColor} p={8} borderRadius="lg" shadow="md">
        <VStack spacing={6} align="stretch">
          <Heading as="h1" size="xl" color={headingColor} textAlign="center">
            お問い合わせ
          </Heading>

          <Text color={textColor} textAlign="center" lineHeight="1.7">
            ReLoopに関するご質問、ご要望、技術的なサポートが必要な場合は、<br />
            Google Formからお気軽にお問い合わせください。
          </Text>

          <Alert status="info" borderRadius="md">
            <AlertIcon />
            <Box>
              <AlertTitle>お問い合わせフォームについて</AlertTitle>
              <AlertDescription>
                お問い合わせは外部のGoogle Formで受け付けています。
                新しいタブでフォームが開きます。
              </AlertDescription>
            </Box>
          </Alert>

          <VStack spacing={6} align="stretch">
            <Button
              leftIcon={<ExternalLinkIcon />}
              colorScheme="blue"
              size="lg"
              onClick={handleGoogleFormOpen}
            >
              Google Formでお問い合わせ
            </Button>

            <Text color={textColor} fontSize="sm" textAlign="center">
              ※ 上記ボタンを押すと新しいタブでGoogle Formが開きます
            </Text>
          </VStack>

          <Box>
            <Heading as="h3" size="md" color={headingColor} mb={3}>
              その他のお問い合わせ方法
            </Heading>
            <VStack spacing={2} align="stretch">
              <Text color={textColor} fontSize="sm">
                <strong>営業時間：</strong>平日 9:00 - 18:00（土日祝除く）
              </Text>
              <Text color={textColor} fontSize="sm">
                <strong>回答時間：</strong>2営業日以内
              </Text>
              <Text color={textColor} fontSize="sm">
                <strong>緊急時：</strong>技術的な緊急事態の場合は、件名に「緊急」と記載してください
              </Text>
            </VStack>
          </Box>
        </VStack>
      </Box>
    </Container>
  );
};

export default Contact;